import React, { useEffect, useState } from 'react'
import { useHookstate } from '@hookstate/core';
import { useLang } from '~/hooks/useLang';
import { getAllWarehouseCheckoutStatus } from './service';
import { Autocomplete, FormControl, TextField } from '@mui/material';

interface FilterautocompleteWarehouseCheckoutStatusProps {
  readonly disabled?: boolean;
  readonly onWarehouseStatusChange: (value: number | null) => void;
  readonly warehouseStautsId?: number | null;
  readonly error?: boolean;
  readonly isRequired?: boolean;
}

export default function FilterautocompleteWarehouseCheckoutStatus({ disabled, onWarehouseStatusChange, warehouseStautsId, error, isRequired }: FilterautocompleteWarehouseCheckoutStatusProps) {
  const { translate } = useLang();
  const [options, setOptions] = useState<readonly any[]>([]);
  const [value, setValue] = useState<any | null>(null);
  const loading = useHookstate(false);

  useEffect(() => {
    loading.set(true);
    getAllWarehouseCheckoutStatus().then((warehouseStatuses) => {
      setOptions(warehouseStatuses);
      loading.set(false);
    }).catch(() => {
      loading.set(false);
    });
  }, []);

  useEffect(() => {
      if (!warehouseStautsId) {
        setValue(null);
      } else {
        const option = options.find((option) => option.id === warehouseStautsId);
        setValue(option ?? null);
      }
    }, [options, warehouseStautsId]);


  return (
    <FormControl fullWidth size="small">
      <Autocomplete
        id="filter-warehouse-status"
        options={options}
        disabled={disabled}
        value={value}
        noOptionsText={translate('No options')}
        size="small"
        loading={loading.get()}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(option) => option.label ?? ''}
        onChange={(_, status) => {
          setValue(status);
          onWarehouseStatusChange(status?.id ?? null);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={`${translate('status')}${isRequired ? ' *' : ''}`}
            error={error}
          />
        )}
        clearText={translate('Clear')}
      />
    </FormControl>
  )
}